module.exports = "/dist/montserrat-latin-500italic.svg?feb994281eaadd007a3cbb94adf20f60";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500italic.svg
// module id = 75
// module chunks = 0